import React, { memo } from "react";
import { useThemeColor } from "../hooks/useThemeColor";

const Section6 = memo(({ index, width, section6Ref }) => {
  const themeColor = useThemeColor(index);

  const experienceData = [
    {
      company: "BuildMvpFast",
      position: "Software Developer",
      location: "Dubai, UAE",
      period: "Mar 2025 – Present",
      description: "I built websites and mobile applications. I've delivered multiple web projects with a strong focus on clean UI, AI integrations, SEO best practices, and secure, scalable architecture. I've also built and successfully launched multiple mobile applications on the App Store using React Native, with a strong emphasis on performance, smooth user experience, and long-term maintainability.",
      skills: ["Next.js", "Node.js", "React Native", "AWS", "Zustand", "Tailwind CSS", "PostgreSQL", "Supabase", "AI Integration", "SEO"],
    },
    {
      company: "Alamnack Technologies",
      position: "Full Stack Developer Intern",
      location: "Bangalore, India",
      period: "Jan 2025 – Mar 2025",
      description: "Delivered high-quality full stack web development with backend workflow optimization and AI-driven process implementation. Successfully integrated APIs and designed intuitive UI/UX interfaces, demonstrating impressive development speed and strong commitment to deadlines while achieving successful project outcomes and improved user experiences.",
      skills: ["React", "Next.js", "Node.js", "PostgreSQL", "AWS", "AI Integration", "WebSocket", "Cron Jobs", "REST APIs", "MongoDB"],
    },
    {
      company: "Freelance",
      position: "Full Stack Developer",
      location: "Remote",
      period: "2022 - 2024",
      description: "Developed scalable full stack websites to help businesses grow using modern technologies. Built robust applications with Next.js, Node.js backend, integrated AI features, and deployed on AWS infrastructure with SEO optimization and PostgreSQL database management.",
      skills: ["Next.js", "Node.js", "AI", "PostgreSQL", "SEO", "AWS"],
    },
  ];

  return (
    <div
      ref={section6Ref}
      className="w-full relative flex items-center flex-col gap-[1rem] py-[2rem]"
    >
      <h4
        className={`text-white tracking-[-5px] monospace ${width <= 768 ? "text-[10vw]" : "text-[70px]"}`}
      >
        My <span style={{ color: themeColor }}>experience</span>
      </h4>

      <div className="w-full max-w-[1200px] px-[2rem]">
        {experienceData.map((exp, idx) => (
          <div
            key={idx}
            className={`flex ${
              width > 768 ? "flex-row" : "flex-col"
            } gap-[2rem] mb-[3rem] ${
              idx !== experienceData.length - 1 ? "border-b border-[#404140] pb-[3rem]" : ""
            }`}
          >
            {/* Timeline dot for desktop */}
            {width > 768 && (
              <div className="flex flex-col items-center">
                <div
                  style={{ backgroundColor: themeColor }}
                  className="w-[12px] h-[12px] rounded-full mb-[1rem]"
                ></div>
                <div
                  style={{ backgroundColor: themeColor }}
                  className="w-[2px] h-[100px] opacity-[0.3]"
                ></div>
              </div>
            )}

            {/* Content */}
            <div className="flex-1">
              <div className="flex flex-col gap-[0.5rem]">
                <h5
                  style={{ color: themeColor }}
                  className={`${
                    width > 768 ? "text-[28px]" : "text-[6vw]"
                  } font-medium monospace`}
                >
                  {exp.position}
                </h5>
                <h6 className="text-white text-[18px] font-medium opacity-[0.8] monospace">
                  {exp.company}
                </h6>
                <p className="text-gray-400 text-[14px] monospace opacity-[0.7] mb-[0.5rem]">
                  {exp.location}
                </p>
                <p
                  style={{ color: themeColor }}
                  className="text-[14px] monospace opacity-[0.6] mb-[1rem]"
                >
                  {exp.period}
                </p>
                <p className="text-gray-300 text-[16px] leading-[1.6] mb-[1rem]">
                  {exp.description}
                </p>
                <div className="flex flex-wrap gap-[0.5rem]">
                  {exp.skills.map((skill, skillIdx) => (
                    <span
                      key={skillIdx}
                      className="text-[12px] px-[8px] py-[4px] rounded-[4px] border border-[#404140] text-gray-400 monospace"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

Section6.displayName = 'Section6';

export default Section6;
